export default {
  // GOOGLE_CLIENT_ID:
  //   "266003818522-6prcmaegf4hrjf11mrmbi1q19df3ole4.apps.googleusercontent.com",
  // GOOGLE_CLIENT_SECRET: "iAcDUQkWfrt95dMU4M5d1Fwe",
  GOOGLE_CLIENT_ID:
    "20101597900-lqnqdh1otm43h41h0kkf9i4dmfc0kkja.apps.googleusercontent.com",
  GOOGLE_CLIENT_SECRET: "4x9BxPz3WVTH6Q8MIRItA13Z",
};
